module.exports = __webpack_public_path__ + "img/icon-cross.ddddc777.svg";